
export default {
    props: ['source'],
    data() {
        return {

            interval: 5000,
            bannerHeight: 0
        }
    },
    computed: {
        carouselIndex() {
            return this.$store.state.carouselIndex
        }
    },
    watch: {
        carouselIndex(item) {
            this.$refs.carousel.setActiveItem(item);
            this.$store.commit('SET_CAROUSEL_index', item)

        }
    },

    mounted() {
        this.carouselChange(0)
        this.imgload();
        window.addEventListener(
            "resize",
            () => {
                this.bannerHeight = this.$refs.bannerHeight[0].height;
                this.imgload();
            },
            false
        );


    },
    methods: {
        carouselChange(item) {
            this.$store.commit('SET_CAROUSEL_index', item)
        },
        imgload() {
            this.$nextTick(() => {
                this.bannerHeight = this.$refs.bannerHeight[0].height >  this.bannerHeight?this.$refs.bannerHeight[0].height:'';


            })
        },
    }
}
